<template>
  <div id="wish" class="page">
    <div id="foto_container">
      <div id="foto">
        <img src="../assets/img/ben-2018.jpeg">
      </div>
      <div id="kidsname">
          <p>Wunsch</p>
      </div>
    </div>
    <div id="wishinfo">
      <div class="columns">
        <div class="column">
         <p><input placeholder="Wunsch" name="name" v-model="wish.name"></p>
          <p><input placeholder="Preis" name="price" v-model="wish.price"></p>
          <p><input placeholder="Url" name="url" v-model="wish.url"></p>
          <p><input placeholder="Bild" name="image" v-model="wish.image"></p>
          
          <div class="actions">
            <p><a @click.prevent="postWish" class="button">
            Wunsch posten
            </a></p>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {db} from '../service/firebase';  
export default {
  name: 'Wish',
  components: {
    
  },
  data () {
      return {
        wish : {
        'url': null,
        'name':null,
        'price':null,
        'image':null,
        'taken':false
        }
      }
  },
  methods: {
    postWish () {
       var ref =  db.ref('/parties/' + this.$store.state.currentParty + '/wishes' ).push( this.wish )

/*
        var updates = {};
        updates['/parties/' + this.$store.state.currentParty + '/wishes'] = this.user.id;
        var ref =  db.ref().update(updates)

      
      this.$root.$firebaseRefs.wishes.push(
          {
          'url': this.url,
          'name': this.name,
          'price': this.price,
          'info': 'Posted by Matt',
          'created_at': -1 * new Date().getTime()
        })
        .then(this.$router.push('/wishlist'))
*/
    }  
  }
}

</script>
<style>
</style>
